import { Backdrop } from '@room-match/shared-ui-components';
import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { ISocialMediaConstItem, socialMediaList } from 'shared/constants/SOCIAL_MEDIA';
import { ISocialMediaAttributes, ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import { setUser } from 'shared/redux/slicers/user.slicer';
import { useAppSelector } from 'shared/redux/store';
import { talentService } from 'shared/services/talentService';
import { MainCont, SocialList } from './Social.styles';
import { useSocialForm } from './SocialForm';
import SocialItem from './SocialItem/SocialItem';

const { updateTalent } = talentService();

const Social = () => {
  const { user: userState } = useAppSelector((state) => state);
  const { mutateAsync, isLoading } = updateTalent();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const [totalSocialReach, setTotalSocialReach] = useState<string | number>(0);

  const convertNumber = (n: string | number) => {
    return Math.abs(Number(n)) >= 1.0e9
      ? (Math.abs(Number(n)) / 1.0e9).toFixed(2) + 'B'
      : Math.abs(Number(n)) >= 1.0e6
        ? (Math.abs(Number(n)) / 1.0e6).toFixed(2) + 'M'
        : Math.abs(Number(n)) >= 1.0e3
          ? (Math.abs(Number(n)) / 1.0e3).toFixed(2) + 'K'
          : Math.abs(Number(n));
  };

  useEffect(() => {
    if (userState && !isLoading) {
      if (userState?.user?.attributes.social_media_accounts === null) {
        const initialSocialMediaObject = socialMediaList.reduce((acc: any, item: ISocialMediaConstItem, index) => {
          acc[index] = {
            platform: item.platform,
            url: '',
            followers: 0,
            enabled: false,
          };
          return acc;
        }, {});
        mutateAsync(
          {
            social_media_accounts: initialSocialMediaObject,
          },
          {
            onSuccess: async () => {
              await queryClient.invalidateQueries(['me']);
            },
          },
        );
      } else {
        const obj: any = userState?.user?.attributes.social_media_accounts;
        const arr = Object.entries(obj);
        let _total = 0;

        arr.forEach((e) => {
          const j: any = e.filter((_: any, i: number) => i > 0);

          j.forEach((i: ISocialMediaAttributes) => {
            if (i.enabled && i.url) {
              _total += Number(i.followers);
            }
          });
        });

        setTotalSocialReach(convertNumber(_total));
      }
    }
  }, [userState]);

  const handleSubmit = (values: ITalentUpdatePayload) => {
    mutateAsync(values, {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['me']);
        dispatch(
          setUser({
            user: {
              ...userState.user,
              attributes: {
                ...userState.user?.attributes,
                social_media_accounts: values.social_media_accounts,
              },
            },
          }),
        );
      },
    });
  };

  const { form } = useSocialForm({
    onSubmit: handleSubmit,
    data: userState?.user?.attributes.social_media_accounts,
  });

  return (
    <MainCont>
      <p style={{ fontSize: 25 }}>Social</p>
      <p style={{ marginTop: 5, fontSize: 15 }}>Social Reach: {totalSocialReach}</p>
      <SocialList>
        {socialMediaList.map((i: ISocialMediaConstItem, index) => (
          <SocialItem socialMedia={i} name={i.placeholder} key={index} index={index} form={form} />
        ))}
      </SocialList>
      <Backdrop isLoading={isLoading} />
    </MainCont>
  );
};

export default Social;
